import { Gift, ArrowRight } from 'lucide-react'
import { Modal } from '@/components/Modal'
import { useThemeColors } from '@/hooks/useThemeColors'
import { FONT_BODY } from '@/config/theme'

// Existing Tally feedback form — mirrors LINKS.feedback in components/Layout/index.tsx.
// Kept as a local constant so this modal is fully self-contained (no wallet/data/flag deps).
export const FEEDBACK_URL = 'https://tally.so/r/PdrEEQ'

interface ReferralComingSoonModalProps {
  show: boolean
  onClose: () => void
}

/**
 * Static "Referral Program — Coming Soon" modal (issue #32). Opened from the header referral icon.
 *
 * Purely informational: lets a prospective referrer know the program is coming and gives them a way
 * to reach us (the existing Tally feedback form). It does NOT touch referrals themselves — no wallet
 * connect, no data fetch, no dependency on the backend REFERRALS_ENABLED flag. The real /refer,
 * /refer/dashboard and /rewards routes stay redirected to "/" until the server-flag gate lands.
 */
export function ReferralComingSoonModal({ show, onClose }: ReferralComingSoonModalProps) {
  const c = useThemeColors()

  return (
    <Modal show={show} onClose={onClose} title="Referral Program — Coming Soon">
      <div style={{ padding: 20, fontFamily: FONT_BODY }}>
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          width: 48, height: 48, borderRadius: '50%', background: c.aB,
          margin: '0 auto 16px',
        }}>
          <Gift size={22} color={c.ac} strokeWidth={2} />
        </div>

        <p style={{
          fontSize: 14, lineHeight: 1.6, color: c.mu,
          textAlign: 'center', margin: '0 0 20px',
        }}>
          Refer &amp; Earn is on the way. Join the waitlist or ask for more info and we&apos;ll be in touch.
        </p>

        <a
          href={FEEDBACK_URL}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6,
            width: '100%', boxSizing: 'border-box',
            padding: '12px 16px', borderRadius: 12,
            background: c.ac, color: '#FFFFFF',
            fontSize: 15, fontWeight: 650, textDecoration: 'none',
            fontFamily: FONT_BODY, transition: 'all 0.15s',
          }}
        >
          <span>Join the waitlist</span>
          <ArrowRight size={15} />
        </a>
      </div>
    </Modal>
  )
}
